<template>
    <div>
        <NavBarLight></NavBarLight><br><br>
        <div class="dashboard-content">
            <div class="row">
				
				<div class="row" id="header-image">
					<NotifyCard></NotifyCard>
				</div>

                <div class="row tab-area">
                  <nav class="nav">
                        
                        <a v-if="tab_selected !== 'web-development'" class="nav-link" href="#" @click="navSelected('web-development')">Web Development</a>
                        <a v-else class="nav-link nav-link-selected" href="#">Web Development</a>

                        <a v-if="tab_selected !== 'ux-design'" class="nav-link" href="#" @click="navSelected('ux-design')">UX Design</a>
                        <a v-else class="nav-link nav-link-selected" href="#">UX Design</a>

                        <a v-if="tab_selected !== 'mobile-development'" class="nav-link" href="#" @click="navSelected('mobile-development')">Mobile Development</a>
                        <a v-else class="nav-link nav-link-selected" href="#">Mobile Development</a>

                        <a v-if="tab_selected !== 'data-science'" class="nav-link" href="#" @click="navSelected('data-science')">Data Science</a>
                        <a v-else class="nav-link nav-link-selected" href="#">Data Science</a>

                        <a v-if="tab_selected !== 'product-management'" class="nav-link" href="#" @click="navSelected('product-management')">Product Management</a>
                        <a v-else class="nav-link nav-link-selected" href="#">Product Management</a>

                    </nav>
                </div>

                
                <div class="row tab-area">
                    
                    <div class="col">
                        <div class="input-group">
                            <select v-if="tab_selected === 'web-development'" class="custom-select" id="category-select" v-model="category">
                                <option selected>Category</option>
                                <option value="Front-end">Front-end</option>
                                <option value="Back-end">Back-end</option>
                                <option value="Full-stack">Full-stack</option>
                                <option value="Interview Prep">Interview Prep</option>
                            </select>

                            <select v-else-if="tab_selected === 'ux-design'" class="custom-select" id="category-select" v-model="category">
                                <option selected>Category</option>
                                <option value="ux design">UX Design</option>
                                <option value="ux research">UX Research</option>
                                <option value="visual design">Visual Design</option>
                            </select>

                            <select v-else-if="tab_selected === 'mobile-development'" class="custom-select" id="category-select" v-model="category">
                                <option selected>Category</option>
                                <option value="flutter">Flutter</option>
                                <option value="react native">React Native</option>
                                <option value="pwa">PWA</option>
                                <option value="android">Android</option>
                                <option value="ios">iOS</option>
                            </select>

                            <select v-else-if="tab_selected === 'data-science'" class="custom-select" id="category-select" v-model="category">
                                <option selected>Category</option>
                                <option value="Machine Learning">Machine Learning</option>
                                <option value="Deep Learning">Deep Learning</option>
                                <option value="TensorFlow">TensorFlow</option>
                                <option value="Reinforcement Learning">Reinforcement Learning</option>
                            </select>

                            <select v-if="tab_selected === 'product-management'" class="custom-select" id="category-select" v-model="category">
                                <option selected>Category</option>
                                <option value="ux-design">UX Design</option>
                                <option value="business">Business</option>
                                <option value="ai">AI</option>
                            </select>
                        </div>
                    </div>


                    <div class="col">
                        <div class="input-group">
                            <select class="custom-select" id="duration-select" v-model="duration">
                                <option selected>Duration</option>
                                <option value="short">Short</option>
                                <option value="medium">Medium</option>
                                <option value="long">Long</option>
                            </select>
                        </div>
                    </div>



                    <div class="col">
                        <div class="input-group">
                            <select class="custom-select" id="certificate-select" v-model="certificate">
                                <option selected>Certificate</option>
                                <option value="medium">Medium</option>
                                <option value="strong">Strong</option>
                                <option value="very strong">Very Strong</option>
                            </select>
                        </div>
                    </div>


                    <div class="col">
                        <div class="input-group">
                            <select class="custom-select" id="level-select" v-model="level">
                                <option selected>Level</option>
                                <option value="Beginner">Beginner</option>
                                <option value="Intermediate">Intermediate</option>
                                <option value="Advanced">Advanced</option>
                            </select>
                        </div>
                    </div>

                

                </div>


                <div class="container" id="job-cards">
                    
                    <h1 v-if="tab_selected === 'web-development'" class="heading-dashboard">Top Web Development courses</h1>
                    <h1 v-else-if="tab_selected === 'ux-design'" class="heading-dashboard">Top UX Design courses</h1>
                    <h1 v-else-if="tab_selected === 'mobile-development'" class="heading-dashboard">Top Mobile Development courses</h1>
                    <h1 v-else-if="tab_selected === 'data-science'" class="heading-dashboard">Top Data Science courses</h1>
                    <h1 v-else-if="tab_selected === 'product-management'" class="heading-dashboard">Top Product Management courses</h1>

                    <div class="row">
                        <LearnCard v-for="(course, index) in filteredList" :key="index" class="challenge-card"
                            v-bind:level = "course.level"
                            v-bind:skill = "course.name"
                            v-bind:link = "course.link"
                            v-bind:platform = "course.platform"
                            v-bind:iconUrl = "course.icon"
                            v-bind:slug="course['.key']"
                            v-bind:domain="tab_selected">
                        </LearnCard>
                    </div>
                </div>
				
			</div>
            
        </div>
       
    </div>

</template>



<script>
import NavBarLight from '@/components/NavBarLight.vue'
import NotifyCard from '@/components/NotifyCard.vue'
import ChallengeCard from '@/components/ChallengeCard.vue'
import JobCard from '@/components/JobCard.vue'
import firebase from '../services/firebase'
import _ from 'lodash'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import LearnCard from '@/components/LearnCard.vue'
import amplitude from 'amplitude-js/amplitude'



(function(c,a){if(!a.__SV){var b=window;try{var d,m,j,k=b.location,f=k.hash;d=function(a,b){return(m=a.match(RegExp(b+"=([^&]*)")))?m[1]:null};f&&d(f,"state")&&(j=JSON.parse(decodeURIComponent(d(f,"state"))),"mpeditor"===j.action&&(b.sessionStorage.setItem("_mpcehash",f),history.replaceState(j.desiredHash||"",c.title,k.pathname+k.search)))}catch(n){}var l,h;window.mixpanel=a;a._i=[];a.init=function(b,d,g){function c(b,i){var a=i.split(".");2==a.length&&(b=b[a[0]],i=a[1]);b[i]=function(){b.push([i].concat(Array.prototype.slice.call(arguments,
    0)))}}var e=a;"undefined"!==typeof g?e=a[g]=[]:g="mixpanel";e.people=e.people||[];e.toString=function(b){var a="mixpanel";"mixpanel"!==g&&(a+="."+g);b||(a+=" (stub)");return a};e.people.toString=function(){return e.toString(1)+".people (stub)"};l="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
    for(h=0;h<l.length;h++)c(e,l[h]);var f="set set_once union unset remove delete".split(" ");e.get_group=function(){function a(c){b[c]=function(){call2_args=arguments;call2=[c].concat(Array.prototype.slice.call(call2_args,0));e.push([d,call2])}}for(var b={},d=["get_group"].concat(Array.prototype.slice.call(arguments,0)),c=0;c<f.length;c++)a(f[c]);return b};a._i.push([b,d,g])};a.__SV=1.2;b=c.createElement("script");b.type="text/javascript";b.async=!0;b.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?
    MIXPANEL_CUSTOM_LIB_URL:"file:"===c.location.protocol&&"//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn4.mxpnl.com/libs/mixpanel-2-latest.min.js";d=c.getElementsByTagName("script")[0];d.parentNode.insertBefore(b,d)}})(document,window.mixpanel||[]);
    mixpanel.init("b0dc58aebea6769e678f46bd7ac08382");


export default {
    name: 'Dashboard',
    components: {
        NavBarLight,
        NotifyCard,
        JobCard,
        ChallengeCard,
        PulseLoader,
        LearnCard
    },
    data: function() {
        return {
            challenges: [],
            jobs: [],
            theUser: null,
            isAuthenticated: false,
            userChallengeStatus: {},
            fbLoaded: false,
            loading: true,
            color: '#524aed',
            size: '8px',
            tab_selected: 'web-development',
            category: 'Category',
            duration: 'Duration',
            certificate: 'Certificate',
            level: 'Level',
            current_list: null,
            original_list: null
        }
    },
    computed: {
        orderedChallenges: function() {
            return _.orderBy(this.challenges, 'Timestamp');
        },

        filteredList: function() {
            this.current_list = this.original_list;
            if (this.category !== 'Category') {
                this.categoryChanged();
            } 

            if (this.duration !== 'Duration') {
                this.durationChanged();

            }

            if (this.level !== 'Level') {
                console.log('in computed, calling levelChanged');
                this.levelChanged();
            }

            if (this.certificate !== 'Certificate') {
                this.certificateChanged();
            }

            return this.current_list;
        }
    },
    created: function() {

        this.original_list = this.web_dev;

        firebase.auth().onAuthStateChanged((user) => {
            if(user) {
                this.theUser = user;
                var full_name = this.theUser.displayName;
                var first_name = full_name.split(" ");
                mixpanel.identify(this.theUser.uid);
                mixpanel.register({
                    "name": this.theUser.displayName,
                    "email": this.theUser.email,
                    "first_name": first_name[0],
                    "id": this.theUser.uid,
                    "last_login": new Date()
                });

                mixpanel.people.set({
                    "$name": this.theUser.displayName,
                    "$email": this.theUser.email,
                    "$first_name": first_name[0],
                    "$id": this.theUser.uid,
                    "$last_login": new Date()
                });
                  
                mixpanel.track("user already logged in", {
                    "user_id": this.theUser.uid,
                    "email": this.theUser.email,
                    "id": this.theUser.uid
                });

                this.isAuthenticated = true;

                firebase.database().ref('user_submissions/' + firebase.auth().currentUser.uid).on('value', (submissions) => {
                    submissions.forEach((submission) => {
                        this.userChallengeStatus[submission.key] = submission.val().status;
                        this.fbLoaded = true;
                    });
                });

            } else {
                this.isAuthenticated = false;
            }
        });
    },
    /*firebase: {
         challenges: firebase.database().ref('challenges/UX').orderByChild('Enabled').equalTo(true),
         jobs: firebase.database().ref('jobs').orderByChild('timestamp')
    },*/
    firebase() {
        return {
            challenges: {
                source: firebase.database().ref('challenges/UX').orderByChild('Enabled').equalTo(true),
                readyCallback: () => this.loading = false
            },
            jobs: {
                source: firebase.database().ref('jobs').orderByChild('timestamp').limitToFirst(6),
                readyCallback: () => this.loading = false
            },
            web_dev: {
                source: firebase.database().ref('web_development'),
                readyCallback: () => this.loading = false
            },
            ux_design: {
                source: firebase.database().ref('ux_design'),
                readyCallback: () => this.loading = false
            },
            mobile_dev: {
                source: firebase.database().ref('mobile_development'),
                readyCallback: () => this.loading = false
            },
            data_science: {
                source: firebase.database().ref('data_science'),
                readyCallback: () => this.loading = false
            },
            product_management: {
                source: firebase.database().ref('product_management'),
                readyCallback: () => this.loading = false
            }
        }
    },
    methods: {
        ctaFunc: function() {
            mixpanel.track("dashboard.vue, ctaFunc");
        },
        userStatus: function(slug) {
            if (this.fbLoaded) {
                if (this.userChallengeStatus[slug] === "Approved") {
                    console.log("user challenge status value is " + this.userChallengeStatus[slug]);
                    return "SUBMIT WORK";
                }

                else {
                    return "TAKE CHALLENGE";
                }
            }

            else {
                return "TAKE CHALLENGE";
            }
            
        },

        startLearning: function(slug) {

            if ((localStorage.getItem("token") === "null") || (localStorage.getItem("token") === null)) {
                var provider = new firebase.auth.GoogleAuthProvider();
                firebase.auth().signInWithPopup(provider).then(function(result) {
                    var user = result.user;
                    var token = result.credential.accessToken;
                    localStorage.token = token;
                    
                    if (user) {
                        console.log("user with email" + user.email + "is signed in");
                        mixpanel.track("new login in dashboard", {
                            "user_id": user.uid,
                            "email": user.email
                        });
                    }
                }).catch(function(error) {
                    console.log("signin error with errorCode" + error.code + " and message " + error.message); 
                })
            } else {
                mixpanel.track("dashboard click on " + slug, {
                "learning_module": slug,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
                });

                if (slug === 'react' || slug === 'react-native' || slug === 'ui-design' || slug === 'modern-javascript' || slug === 'vue') {
                    this.$router.push(this.$route.path + '/learn/' + slug + '/start-learning');
                }
            }
            
            
        },

        clickFunc: function(slug_sent, apply, challengeStatus) {
            
            if (this.theUser !== null) {
                mixpanel.track("clicked on challenge card", {
                    "challenge_name": slug_sent,
                    "user_id": this.theUser.uid,
                    "email": this.theUser.email
                });
            }
            
        
            if ((localStorage.getItem("token") === "null") || (localStorage.getItem("token") === null)) {
                var provider = new firebase.auth.GoogleAuthProvider();
                firebase.auth().signInWithPopup(provider).then(function(result) {
                    var user = result.user;
                    var token = result.credential.accessToken;
                    localStorage.token = token;
                    
                    if (user) {
                        
                        mixpanel.track("new login in dashboard", {
                            "user_id": user.uid,
                            "email": user.email
                        });
                    }
                }).catch(function(error) {
                    console.log("signin error with errorCode" + error.code + " and message " + error.message); 
                })
            }
            else {
                if (apply !== true) {
                    if (challengeStatus === "LIVE") {
                        this.$router.push(this.$route.path + '/challenge/' + slug_sent);
                    } else if (challengeStatus === "VOTING") {
                        this.$router.push(this.$route.path + '/challenge/' + slug_sent + '/voting');
                    } else if (challengeStatus === "ENDED") {
                        this.$router.push(this.$route.path + '/challenge/' + slug_sent + '/results');
                    }
                    
                } else {
                    if (this.userChallengeStatus[slug_sent] === "Approved") {
                        this.$router.push(this.$route.path + '/apply/' + slug_sent + '/challenge');
                    }
                    else {
                        this.$router.push(this.$route.path + '/apply/' + slug_sent);
                    }
                }
            }
            
            
        },

        resetFilters: function(nav) {
            this.category = 'Category';
        },

        navSelected: function(nav) {
            console.log('nav selected is ' + nav);
            var topic = {};
            topic.key = '' + nav;
            amplitude.getInstance().init('e145c56a131ad5d30cfe488387c01eac');
            amplitude.getInstance().logEvent("topic selected", topic);
            this.resetFilters();
            this.tab_selected = nav;
            switch(nav) {
                case "web-development":
                    this.original_list = this.web_dev;
                    break;
                
                case 'ux-design':
                    this.original_list = this.ux_design;
                    break;
                
                case 'mobile-development': 
                    this.original_list = this.mobile_dev;
                    break;
                
                case 'data-science':
                    this.original_list = this.data_science;
                    break;

                case 'product-management':
                    this.original_list = this.product_management;
                    break;

                default: 
                    break;
            }   
        },

        categoryChanged: function() {
            var category = this.category;
            

            var arr = _.filter(this.current_list, function(e) {
                
                if (category === e.category) {
                    return e.category;
                }
            });

            this.current_list = arr;

        },

        certificateChanged: function() {
            var certificate = this.certificate;
            var platforms = [];
            
            switch(certificate) {
                case "medium":
                    platforms.push('Udemy', 'Coursera', 'EdX', 'Udacity');
                    break;
                
                case "strong":
                    platforms.push('Coursera', 'EdX', 'Udacity');
                    break;
                
                case "very strong":
                    platforms.push('Coursera', 'EdX');
                    break;

                default:
                    return;

            }

            var arr = _.filter(this.current_list, function(e) {
                
                if (platforms.includes(e.platform)) {
                    return e.platform;
                }
            });

            this.current_list = arr;

        },

        durationChanged: function() {
            var a = 0;
            var b = 10000000;
            
            switch(this.duration) {
                case 'short':
                    a = 0;
                    b = 15;
                    break;
                
                case 'medium': 
                    a = 16; 
                    b = 30;
                    break;
                
                case 'long':
                    a = 31;
                    b = 100000000;
                    break;

                default:
                    return;
            }

            var arr = _.filter(this.current_list, function(e) {
                if (e.duration >= a && e.duration <= b) {
                    return e.duration;
                }
            });

            this.current_list = arr;

        },


        levelChanged: function() {
            
            var level = this.level;

            var arr = _.filter(this.current_list, function(e) {
                if (e.level === level || e.level === 'All levels') {
                    return e.level;
                } 
            });

            this.current_list = arr;
        
        }
    }
}

</script>



<style>

    @media (min-width: 701px) {
        .heading-dashboard {
            margin-top:40px;
            font-size: 1.55rem;
            margin-left: 2.5%;
            text-align: left;
            font-family: Avenir;
        }
    }
    

    @media (max-width: 700px) {
        .heading-dashboard {
            margin-top:40px;
            font-size: 1.55rem;
            text-align: center;
            font-family: Avenir;
        }
    }

    .dashboard-content {
        padding-top:25px;
        background-color: #f8faff;
    }

    @media (min-width: 430px) {
        #header-image {
            margin-top:20px; 
            color:#555;
            margin-left:14.7%;
            margin-right:14.7%;
            margin-bottom:20px;
        }

        .tab-area {
            margin-top:20px; 
            color:#555;
            margin-left:14.7%;
            margin-right:14.7%;
            margin-bottom:20px;
        }
        
    }
    
    .custom-select {
        margin-right: 20px;
    }

    .challenge-card{
        width:28.7%;
    }

    @media (min-width: 768px) and (max-width: 992px) {
        .challenge-card {
            width: 45%;
        }

        #header-image {
            margin-top:3%; 
            color:#555;
            margin-left:16%;
            margin-right:13%;
            margin-bottom:20px;
        }

        .tab-area {
            margin-top:3%; 
            color:#555;
            margin-left:16%;
            margin-right:13%;
            margin-bottom:20px;
        }
    }

    @media (min-width: 600px) and (max-width: 768px) {
        .challenge-card {
            width: 70%;
            margin: auto;
        }

        #header-image {
            margin-top:2%; 
            color:#555;
            margin-left:5%;
            margin-right:5%;
            margin-bottom:20px;
        }

        .tab-area {
            margin-top:2%; 
            color:#555;
            margin-left:5%;
            margin-right:5%;
            margin-bottom:20px;
        }

    }

    @media (min-width: 430px) and (max-width:600px) {
        .challenge-card {
            width: 80%;
            margin: auto;
        }

        #header-image {
            margin-top:2%; 
            color:#555;
            margin-left:2%;
            margin-right:2%;
            margin-bottom:2%;
            display: none;
        }

        .tab-area {
            margin-top:2%; 
            color:#555;
            margin-left:2%;
            margin-right:2%;
            margin-bottom:2%;
        }

        .custom-select {
            margin-right: -40px;
        }

    }

    @media (max-width:430px) {
        .challenge-card {
            width: 90%;
            margin:auto;
        }

        #header-image {
            margin-top:0% !important; 
            color:#555;
            margin-left:2%;
            margin-right:2%;
            margin-bottom:20px;
            display: none;
        }

        .tab-area {
            margin-top:2%; 
            color:#555;
            margin-left:2%;
            margin-right:2%;
            margin-bottom:20px;
        }

        .custom-select {
            margin-right: -44px;
        }
    }

    @media (min-width: 768px) {
        #challenge-cards {
            margin-left:11.9%;
            margin-bottom:10%;
        }
    }

    @media (min-width: 768px) {
        #job-cards {
            margin-left:11.9%;
            margin-bottom:40px;
        }
    }
        

    .loader {
        margin-left: 40%;
    }


    .nav-link {
        display: block;
        color: #444;
        padding-right: 20px;
        padding-left: 20px;
        text-decoration: none;
    }

    .nav-link-selected {
        color: #6c63ff;
        text-decoration: none;
        border: #fff 1px solid;
        border-radius: 8px;
        background-color: #fff;
        box-shadow: 2px 1px 2px 0px rgba(1, 2, 2, 0.15);
        transition: all 0.3s ease;
    }

    .custom-select:focus {
        outline-color: none !important;
        outline-style: none !important;
        outline-width: none !important;
    }

    .input-group {
        width: 110%;
        margin-bottom: 10px;
    }

    .custom-select {
       font-size: 0.8rem;
       line-height: 1.2;
       border-radius: 6px;
       border: #fff 1px solid;
       box-shadow: 1px 0.5px 1px 0px rgba(1, 2, 2, 0.15);
       transition: all 0.3s ease;
       background-color: white;
       color: #6c63ff;
    }

    .bootstrap-select .btn:focus {
        outline-color: none !important;
        outline-style: none !important;
        outline-width: none !important;
    }

    a:hover {
        color: #6c63ff;
        text-decoration: none;
    }

    .nav {
        font-weight: bold;
    }

    .filter-nav {
        font-weight: normal;
    }

    .col {
        padding-left: 0 !important;
        padding-right: 50px !important;
    }

</style>
